import React from 'react'

// prettier-ignore
export const EquipmentVista = {
  Dashboard: React.lazy(() => import('./dashboard')),
  Create:    React.lazy(() => import('./create')),
  Edit:      React.lazy(() => import('./edit')),
}
